import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-reminder-type';
const API_DETAIL = (id: number) => `/p-crm-reminder-type/${id}`;

export interface ReminderType {
  id: number;
  pr_descr?: string;
}

export const useReminderTypes = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<ReminderType[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    reminderTypes: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useReminderType = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<ReminderType>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    reminderType: data,
    isLoading,
    isError: error,
    mutate,
  };
};
